import React from 'react'

import CommonFieldOptions from './CommonFieldOptions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglass } from '@fortawesome/free-solid-svg-icons'
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons'
import { ALERT_MODALS } from "../../../constants/app";
import RequiredPdfForVirtualFieldAlertModal
  from "../../modals/requiredPdfForVirtualFieldAlertModal/RequiredPdfForVirtualFieldAlertModal";
import { getBlankPdf } from "../../../constants/blankPdf";

export default class GridCellFieldOptions extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentShowAlertModal: null
    }
  }

  handleDetectGridStructure = () => {
    if (this.props.isCustomFile) {
      this.props.detectGridStructure(this.props.object.id);
    } else {
      this.setState({
        currentShowAlertModal: ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL
      })
    }
  };

  render() {
    const row = this.props.object.fieldProperties.structureCoordinates.y + 1;
    const col = this.props.object.fieldProperties.structureCoordinates.x + 1;

    return (
      <>
        <CommonFieldOptions {...this.props} >
          <div className="form-group row">
            <label htmlFor="objectTypeField" className="col-sm-4 col-form-label">Type</label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                id="objectTypeField"
                value="Grid Cell"
                disabled={true}
              />
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="gridCellColField" className="col-sm-4 col-form-label">
              Select Cell:
            </label>
            <div className="col-sm-6">
              <input type="text" name="gridCellField" id="gridCellField" className="form-control" disabled
                     value={"row: " + row + ", col: " + col}
              />
            </div>
            <button
              disabled={this.props.detectingFields}
              onClick={this.handleDetectGridStructure}
              className="btn condensed-button pull-right btn-success">
              {this.props.detectingFields ? <FontAwesomeIcon icon={faHourglass} /> : <FontAwesomeIcon icon={faCrosshairs} />}
            </button>
          </div>
        </CommonFieldOptions>

        {this.state.currentShowAlertModal === ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL && (
          <RequiredPdfForVirtualFieldAlertModal isOpen={this.state.currentShowAlertModal === ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL}
                                                handleClose={() => this.setState({currentShowAlertModal: null}) }
                                                handleUploadPdf={this.props.handleUploadPdf}/>
        )}
      </>
    );
  }
}
